<template>
  <div>
      <AllCase  :tableList="caseList" :total="caseTotal"  @caseQueryChange="caseQueryChange"></AllCase>
  </div>
</template>

<script>
import AllCase from './allCase.vue'
import {enterpriseCasePage} from '../../utils/interface'
export default {
    components:{AllCase},
    data(){
        return{
            caseList:[
               ],//案例列表
            caseTotal:0,
          enterpriseUuid:'',
        }
    },
    mounted(){

    },
    methods:{
        init(enterpriseUuid){
          this.enterpriseUuid = enterpriseUuid;
            let params = {
                current:1,
                pageSize:10,
              title:'',
              reviewList:"1,3",
              enterpriseUuid:enterpriseUuid
            }
            this.getList(params)
        },
        //案例查询参数改变
        caseQueryChange(info){
            console.log("info",info)
            let params = {
              title: info.title,
                current: info.current,
                pageSize: info.pageSize,
              enterpriseUuid:this.enterpriseUuid,
              reviewList:"1,3",
            };
            this.getList(params)
        },
        getList(params){
            enterpriseCasePage(params).then(res=>{
                this.caseList = res.records
                this.caseTotal = parseInt(res.total)
            })
        }
    }
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/components/print/caseList.vue